import { render, staticRenderFns } from "./ShippingRowsEditPanel.vue?vue&type=template&id=ffbbc722"
import script from "./ShippingRowsEditPanel.vue?vue&type=script&lang=js"
export * from "./ShippingRowsEditPanel.vue?vue&type=script&lang=js"
import style0 from "./ShippingRowsEditPanel.vue?vue&type=style&index=0&id=ffbbc722&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports